module.exports = __webpack_public_path__ + "cddea21d349db5a62b94fa3fe46a0b0b.pdf";